import { PASSWORD_CHECKS } from 'utils/constants'

const checkPassword = (password) => {
  return PASSWORD_CHECKS.reduce((a, b) => a && b.regex.test(password), true)
}

export default checkPassword
